// cafeDemoId:634f8fc68e3a955f9e6a5a26
// noteDemoId:635146a940a5b66986b446a5
//Mary's Testing Data >
//1. Lancy's Cafe: 6353af2152dba8ceb6331ee3
//2. Mary's Cafe: 6351e40c2f410a67bdbefe44
//Kris id:6351f5171220024da156f433
//raytest id:6352106a8bf67b40848c763b
//Talisa test cafe id:637607a2a1715465c23962b2
//Talisa second cafe id:637ae8b3c915fa72a52e4900
// tongL id:6369e9b69e4442603c3f0577
import UserAvatar from '../assets/images/defaultAvatar.png';
import CafeAvatar from '../assets/images/default-cafe.png';
import NoteImg from '../assets/images/CafeImage_default.jpg';

const CURRENT_LOGIN_USER = '6369e9b69e4442603c3f0577';
const PROFILE_USER = '6340ff89d7af605cd8c82ff5';
const DEFAULT_NOTE = '6376186ea1715465c23962b5';
const DEFAULT_CAFE = '637607a2a1715465c23962b2';
const DEFAULT_AVATAR = UserAvatar;
const DEFAULT_CAFE_IMG = CafeAvatar;
const DEFAULT_CAFE_SECTION_NUM = 8;
const DEFAULT_NOTE_IMG = NoteImg;

const DEFAULT_NOTE_GALLERY_PAGE = '/search';

export {
  CURRENT_LOGIN_USER,
  PROFILE_USER,
  DEFAULT_NOTE,
  DEFAULT_CAFE,
  DEFAULT_AVATAR,
  DEFAULT_CAFE_IMG,
  DEFAULT_CAFE_SECTION_NUM,
  DEFAULT_NOTE_IMG,
  DEFAULT_NOTE_GALLERY_PAGE,
};
